import { Typography } from '@mui/material'
import React from 'react'
import useStyles from './_styles'

const AutoSaveSatusBar = ({ autoSaving, autoSaved }: any) => {
    const classes = useStyles()

    return (
        <div className={classes.AutoSaveSatusBar}>
            {autoSaving && <Typography className={classes.AutoSaveSatusBarText}>En cours de sauvegarde...</Typography>}
            {autoSaved && <Typography className={classes.AutoSaveSatusBarText}>Modifications sauvegardées</Typography>}
        </div>
    )
}

export default AutoSaveSatusBar
